import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/auth';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import tableStatesReducer from './slices/tableStatesSlice';

const rootReducer = combineReducers({
    auth: authReducer,
    tableStates: tableStatesReducer,
});

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth', 'tableStates'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };